const OPTIONS_ETAT_MATRIMONIAL: Record<
  'key' | 'text' | 'value',
  number | string | string
>[] = [
  {
    key: 1,
    text: 'Célibataire',
    value: 'C',
  },
  {
    key: 2,
    text: 'Divorcé(e)',
    value: 'D',
  },
  {
    key: 3,
    text: 'Veuf(ve)',
    value: 'V',
  },
];

export default OPTIONS_ETAT_MATRIMONIAL;
